// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1mok{border-radius:var(--ds-radius-large,8px)}._18m915vq{overflow-y:hidden}\n._1bsb1c3h{width:50pc}\n._1bsb1osq{width:100%}\n._1reo15vq{overflow-x:hidden}\n._4t3i16xz{height:6pc}\n._4t3iv7uf{height:122px}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
